import React from 'react';
import { renderToString } from 'react-dom/server';
import { MapPropertyList } from '../../../../components/UI/modules';

class MapPropertyInfoWindowView {
  constructor({ element, map }) {
    this.element = element;
    this.map = map;
    this.infoWindow = null;
    this.addMapEvents();
  }

    handleMapClick = (e) => {
      this.closeInfoWindow();

      if (e.placeId) {
        e.stop();
      }
    }

    addMapEvents() {
      // close any instance of infoWindow if click the map
      this.googleHandleMapClick = window.google.maps.event.addListener(this.map, 'click', this.handleMapClick);
    }

    removeMapEvents() {
      window.google.maps.event.removeListener(this.googleHandleMapClick);
    }

    openInfoWindow({ marker, propertyGroup }) {
      if (this.infoWindow) {
        this.infoWindow.close();
      }

      this.infoWindow = new google.maps.InfoWindow({
        content: renderToString(<MapPropertyList properties={propertyGroup.properties} />),
        pixelOffset: new google.maps.Size(-8, -10)
      });
      this.infoWindow.open(this.map, marker);
    }

    closeInfoWindow() {
      if (this.infoWindow) {
        this.infoWindow.close();
        this.infoWindow = null;
      }
    }

    destroy() {
      this.removeMapEvents();
    }
}

export default MapPropertyInfoWindowView;
